import { REPORT_COLUMN_KEYS, SERVER_CUSTOM_EVENT_PREFIX } from '../../constants/dataFieldKeys/reportColumnKeys';
import { getCustomEventName } from './getCustomEventName';
import { getDynamicCalculationColumnDataFieldKey } from './getDynamicCalculationColumnDataFieldKey';
import { isBlockedCustomEvent } from './isBlockedCustomEvent';
import { isCustomEvent } from './isCustomEvent';
import { isDynamicCalculation } from './isDynamicCalculation';
import { isSpecialEvent } from './isSpecialEvent';

export const getColumnDataFieldKey = (key: string): string | undefined => {
  if (REPORT_COLUMN_KEYS[key]) {
    return REPORT_COLUMN_KEYS[key];
  }

  if (isDynamicCalculation(key)) {
    return getDynamicCalculationColumnDataFieldKey(key);
  }

  if (isCustomEvent(key) || isBlockedCustomEvent(key)) {
    return `${SERVER_CUSTOM_EVENT_PREFIX}${getCustomEventName(key)}`;
  }

  if (isSpecialEvent(key)) {
    return key;
  }

  return undefined;
};
